export const FILE_SIZE_LIMIT = 5300000;